import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { DISCOUNT_ORDINARY_FOR_ORDINARY_QUERY } from "./schema";

export const useDiscountOrdinaryForOrdinaryQuery = (hotelID: string, discountId: string) => {
	const { data } = useCustomSuspenseQuery(DISCOUNT_ORDINARY_FOR_ORDINARY_QUERY, {
		variables: { hotelID, discountId },
		fetchPolicy: "no-cache",
	});

	return {
		discountOrdinaryForOrdinaryServerModel: data,
	};
};
